import __request__ from "routing/request";
export function create(category, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.contentui/event_type_category", category, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAll(page = 1, page_size = 50, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/event_type_category", null, { "page": page, "page_size": page_size }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getEventTypeCategoryUiMap(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.contentui/event_type_category/ui_mapping", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getById(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.contentui/event_type_category/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(category, id, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.contentui/event_type_category/${id}`, category, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.contentui/event_type_category/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
